
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("knqHM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "CoordinationStopProvider", () => $b23659af3039c094$export$83d026e3dd5706d);
$parcel$export(module.exports, "SpotlightTourCardInner", () => $b23659af3039c094$export$c5cea928f65b46cd);
$parcel$export(module.exports, "default", () => $b23659af3039c094$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6p0vo = parcelRequire("6p0vo");
var $iK9Lm = parcelRequire("iK9Lm");
var $kBV2f = parcelRequire("kBV2f");

var $7YsrN = parcelRequire("7YsrN");

var $9zZj0 = parcelRequire("9zZj0");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $iqtgH = parcelRequire("iqtgH");
var $aqlRB = parcelRequire("aqlRB");

var $6sTi7 = parcelRequire("6sTi7");

var $gokBr = parcelRequire("gokBr");

var $9ncIL = parcelRequire("9ncIL");

var $jJ7Gw = parcelRequire("jJ7Gw");
const $b23659af3039c094$export$83d026e3dd5706d = ({ stop: stop, children: children })=>children(stop);
const $b23659af3039c094$export$c5cea928f65b46cd = ({ mode: mode, view: view, hasIssueResults: hasIssueResults = false, isAiEnabled: isAiEnabled })=>{
    const [isSpotlightActive, setIsSpotlightActive] = (0, $eJOHy.useState)(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $aqlRB.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { onSetActiveCard: onSetActiveCard } = (0, $gokBr.useSpotlightCoordinationActions)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'ninSpotlightTour'
    });
    const fireStartButtonAnalyticsEvent = (stop)=>{
        if (isAiEnabled) {
            // @ts-expect-error Argument of type 'UIAnalyticsEvent | null' is not assignable to parameter of type 'UIAnalyticsEvent'
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent.clone(), 'start', {
                isAiEnabled: isAiEnabled
            });
            onSetActiveCard((0, $6sTi7.cardKeys).GLOBAL_SCOPE_JQL_BUILDER_NL_TO_JQL, stop);
            return;
        }
        // @ts-expect-error Argument of type 'UIAnalyticsEvent | null' is not assignable to parameter of type 'UIAnalyticsEvent'
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent.clone(), 'start', {
            mode: mode,
            view: hasIssueResults ? view : (0, $9ncIL.views).detail,
            hasIssueResults: hasIssueResults
        });
        stop && stop();
    };
    const fireDismissButtonAnalyticsEvent = ()=>{
        // @ts-expect-error Argument of type 'UIAnalyticsEvent | null' is not assignable to parameter of type 'UIAnalyticsEvent'
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent.clone(), 'dismiss');
    };
    if (isSpotlightActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9zZj0.default), {
        messageId: (0, $9ncIL.getEngagementPlatformlMessageId)((0, $9ncIL.TOUR_MESSAGE_ID)),
        messageType: "engagement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b23659af3039c094$export$83d026e3dd5706d, null, (stop)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kBV2f.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b23659af3039c094$var$SpotlightWrapper, {
            "data-testid": "issue-navigator-changeboarding.common.ui.spotlight.spotlight-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6p0vo.default), {
            key: "nin.changeboarding.start",
            width: 364,
            heading: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $jJ7Gw.default).spotlightTitleIssueTermRefresh : (0, $jJ7Gw.default).spotlightTitle),
            actions: [
                {
                    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7YsrN.default), {
                        weight: "medium",
                        testId: "issue-navigator-changeboarding.common.ui.spotlight.spotlight-card.start"
                    }, formatMessage((0, $jJ7Gw.default).spotlightButtonStartTourText)),
                    onClick: ()=>{
                        setIsSpotlightActive(false);
                        fireStartButtonAnalyticsEvent(stop);
                    }
                },
                {
                    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7YsrN.default), {
                        weight: "medium",
                        testId: "issue-navigator-changeboarding.common.ui.spotlight.spotlight-card.dismiss"
                    }, formatMessage((0, $jJ7Gw.default).spotlightButtonDismissText)),
                    onClick: ()=>{
                        setIsSpotlightActive(false);
                        fireDismissButtonAnalyticsEvent();
                        stop?.();
                    },
                    appearance: 'subtle'
                }
            ]
        }, formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $jJ7Gw.default).spotlightDescIssueTermRefresh : (0, $jJ7Gw.default).spotlightDesc), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
            action: "viewed",
            actionSubject: "screen",
            actionSubjectId: "ninSpotlightStartCard"
        }))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
};
const $b23659af3039c094$var$SpotlightTourCard = ({ mode: mode, view: view, hasIssueResults: hasIssueResults, isAiEnabled: isAiEnabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iK9Lm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b23659af3039c094$export$c5cea928f65b46cd, {
        mode: mode,
        view: view,
        hasIssueResults: hasIssueResults,
        isAiEnabled: isAiEnabled
    }));
var $b23659af3039c094$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
 = $b23659af3039c094$var$SpotlightTourCard;
const $b23659af3039c094$var$SpotlightWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqsw1n9t _19pkpxbi _1xi2pxbi _1pby1fw0",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6sTi7", function(module, exports) {
$parcel$export(module.exports, "cardKeys", () => $fe025dbff69a9482$export$79399c5778983d77);
/**
 * Collection of keys representing individual spotlight cards displayed within the issue navigator.
 */ const $fe025dbff69a9482$export$79399c5778983d77 = {
    GLOBAL_SCOPE_JQL_BUILDER_NL_TO_JQL: 'global-scope.jql-builder-with-ai.natural-language-to-jql',
    GLOBAL_SCOPE_VIEW_SWITCHER: 'global-scope.view-switcher',
    GLOBAL_SCOPE_COLUMN_PICKER: 'global-scope.column-picker',
    JQL_BUILDER_NL_TOGGLE: 'jql-builder-with-ai.natural-language-toggle',
    JQL_BUILDER_NL_TO_JQL: 'jql-builder-with-ai.natural-language-to-jql'
};

});

parcelRegister("gokBr", function(module, exports) {
$parcel$export(module.exports, "useIsActiveSpotlightCard", () => $afabf68402b50fe5$export$ac706a6842f43035);
$parcel$export(module.exports, "useSpotlightCoordinationActions", () => $afabf68402b50fe5$export$d0297e733168e478);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

const $afabf68402b50fe5$var$initialState = {
    cardKey: null,
    onStopCoordination: null
};
const $afabf68402b50fe5$var$actions = {
    onSetActiveCard: (cardKey, stop)=>({ getState: getState, setState: setState })=>{
            const { onStopCoordination: onStopCoordination } = getState();
            setState({
                cardKey: cardKey,
                onStopCoordination: stop ?? onStopCoordination
            });
        },
    onEndTour: ()=>({ getState: getState, setState: setState })=>{
            const { onStopCoordination: onStopCoordination } = getState();
            onStopCoordination && onStopCoordination();
            setState({
                cardKey: null,
                onStopCoordination: null
            });
        }
};
const $afabf68402b50fe5$var$Store = (0, $GtRbT.createStore)({
    initialState: $afabf68402b50fe5$var$initialState,
    actions: $afabf68402b50fe5$var$actions
});
const $afabf68402b50fe5$export$ac706a6842f43035 = (0, $iJq0l.createHook)($afabf68402b50fe5$var$Store, {
    selector: (state, cardKeys)=>Array.isArray(cardKeys) ? state.cardKey !== null && cardKeys.includes(state.cardKey) : state.cardKey === cardKeys
});
const $afabf68402b50fe5$export$d0297e733168e478 = (0, $iJq0l.createActionsHook)($afabf68402b50fe5$var$Store);

});

parcelRegister("jJ7Gw", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0f09b4866478e39$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $e0f09b4866478e39$var$messages = (0, $7qGN1.defineMessages)({
    spotlightTitle: {
        "id": "issue-navigator-changeboarding.common.spotlight.spotlight-card.spotlight-title",
        "defaultMessage": "Welcome to the new issue search \uD83D\uDC4B"
    },
    spotlightDesc: {
        "id": "issue-navigator-changeboarding.common.spotlight.spotlight-card.spotlight-desc",
        "defaultMessage": "Check out our new issue search to find, view, and action issues across your Jira site."
    },
    spotlightButtonStartTourText: {
        "id": "issue-navigator-changeboarding.common.spotlight.spotlight-card.spotlight-button-start-tour-text",
        "defaultMessage": "Show me"
    },
    spotlightButtonDismissText: {
        "id": "issue-navigator-changeboarding.common.spotlight.spotlight-card.spotlight-button-dismiss-text",
        "defaultMessage": "No, thanks"
    },
    spotlightTitleIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.common.spotlight.spotlight-card.spotlight-title-issue-term-refresh",
        "defaultMessage": "Welcome to the new way to search for work items \uD83D\uDC4B"
    },
    spotlightDescIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.common.spotlight.spotlight-card.spotlight-desc-issue-term-refresh",
        "defaultMessage": "Check out our new search to find, view, and action work across your Jira site."
    }
});
var $e0f09b4866478e39$export$2e2bcd8739ae039 = $e0f09b4866478e39$var$messages;

});



//# sourceMappingURL=async-nin-spotlight.e3255859.js.map
